import React from "react";
import { X } from "lucide-react";
import { formatRocDate } from "../../../utils/rocDate";

export default function ProfileDetailsModal({ userData = {}, onClose }) {
  const fields = [
    ["中文全名", userData.fullName || userData.name],
    ["性別", userData.gender],
    ["身份證字號", userData.idNumber],
    ["血型", userData.bloodType],
    ["出生年月日（民國）", formatRocDate(userData.birthday)],
    ["手機號碼", userData.mobile],
    ["通訊地址", userData.address],
    ["電子信箱", userData.personalEmail || userData.email],
    ["畢業學校及科系", userData.education],
    ["銀行帳號（國泰世華 013）", userData.bankAccount],
  ];
  const contact = userData.emergencyContact || {};
  return (
    <div className="fixed inset-0 bg-black/50 z-[100] flex items-center justify-center p-4">
      <section role="dialog" aria-modal="true" aria-label="個人資料" className="bg-white w-full max-w-lg rounded-xl shadow-2xl max-h-[90vh] overflow-y-auto p-6">
        <div className="flex justify-between items-center mb-4 border-b pb-2">
          <h3 className="font-bold text-lg text-slate-800">個人資料</h3>
          <button onClick={onClose} aria-label="關閉個人資料" title="關閉"><X size={20} /></button>
        </div>
        <dl className="grid grid-cols-2 gap-4 text-sm text-slate-700">
          {fields.map(([label, value]) => <div key={label} className="min-w-0">
            <dt className="text-xs text-slate-500 mb-1">{label}</dt>
            <dd className="break-words whitespace-pre-wrap">{value || "未填寫"}</dd>
          </div>)}
        </dl>
        <div className="mt-4 border-t pt-3 text-sm text-slate-700">
          <h4 className="font-bold mb-2">工作經歷</h4>
          {(userData.workExperience || []).map((item, index) => <p key={index} className="break-words mb-2">{[item.company, item.job, item.period].filter(Boolean).join(" / ") || "未填寫"}</p>)}
          <h4 className="font-bold mt-3 mb-2">家庭成員</h4>
          {(userData.familyMembers || []).map((item, index) => <p key={index} className="break-words mb-2">{[item.name, item.title].filter(Boolean).join(" / ") || "未填寫"}</p>)}
          <h4 className="font-bold mt-3 mb-2">緊急聯絡人</h4>
          <p className="break-words">{[contact.name, contact.relation || contact.title, contact.mobile].filter(Boolean).join(" / ") || "未填寫"}</p>
        </div>
      </section>
    </div>
  );
}
